module.exports = __webpack_public_path__ + "img/xueShan2.34c23c84.png";